import React, { useEffect, useRef, useState } from 'react';

const normalizeLabel = (value) => (typeof value === 'string' ? value.trim() : '');

const EditIcon = () => (
  <svg viewBox="0 0 24 24" className="inspector__field-label-icon" aria-hidden="true">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </svg>
);

const ResetIcon = () => (
  <svg viewBox="0 0 24 24" className="inspector__field-label-icon" aria-hidden="true">
    <path d="M3 7v4h4" />
    <path d="M3 11c1.8-3 4.6-5 8.2-5 4.6 0 8.3 3.7 8.3 8.3 0 4.6-3.7 8.3-8.3 8.3-3.3 0-6.2-1.9-7.6-4.7" />
  </svg>
);

const EditableInspectorLabel = ({ label, defaultLabel, onCommit }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(label || defaultLabel || '');
  const inputRef = useRef(null);

  const resolvedDefault = normalizeLabel(defaultLabel);
  const rawLabel = typeof label === 'string' ? label : null;
  const normalizedLabel = normalizeLabel(rawLabel);
  const isHidden = rawLabel !== null && normalizedLabel === '';
  const resolvedLabel = isHidden ? resolvedDefault : (normalizedLabel || resolvedDefault);
  const hasCustom = rawLabel !== null && normalizedLabel !== '' && normalizedLabel !== resolvedDefault;
  const isResettable = isHidden || hasCustom;

  useEffect(() => {
    if (!isEditing) {
      setDraft(isHidden ? '' : resolvedLabel);
    }
  }, [isEditing, resolvedLabel, isHidden]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const commitDraft = () => {
    const next = normalizeLabel(draft);
    setIsEditing(false);
    if (next === '') {
      if (typeof onCommit === 'function') {
        onCommit('');
      }
      return;
    }
    if (next === resolvedDefault) {
      if (isResettable && typeof onCommit === 'function') {
        onCommit(null);
      }
      return;
    }
    if (next !== resolvedLabel && typeof onCommit === 'function') {
      onCommit(next);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget.blur();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      setIsEditing(false);
      setDraft(resolvedLabel);
    }
  };

  return (
    <div className="inspector__field-label">
      {isEditing ? (
        <input
          ref={inputRef}
          className="inspector__field-label-input"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onBlur={commitDraft}
          onKeyDown={handleKeyDown}
        />
      ) : (
        <>
          <span className={`inspector__field-label-text${isHidden ? ' inspector__field-label-text--hidden' : ''}`}>
            {resolvedLabel}
          </span>
          <button
            type="button"
            className="inspector__field-label-action"
            onClick={() => {
              if (isResettable) {
                if (typeof onCommit === 'function') {
                  onCommit(null);
                }
                return;
              }
              setIsEditing(true);
            }}
            title={isResettable ? 'Restablecer etiqueta' : 'Editar etiqueta'}
          >
            {isResettable ? <ResetIcon /> : <EditIcon />}
          </button>
        </>
      )}
    </div>
  );
};

export default EditableInspectorLabel;
